import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

function normalizeSymbols(symbols) {
  if (!Array.isArray(symbols)) return [];
  const out = [];
  const seen = new Set();
  symbols.forEach((raw) => {
    const symbol = String(raw || '').trim().toUpperCase();
    if (!symbol || seen.has(symbol)) return;
    seen.add(symbol);
    out.push(symbol);
  });
  return out;
}

export function useLivePricesQuery(symbols, options = {}) {
  const normalizedSymbols = useMemo(() => normalizeSymbols(symbols), [symbols]);
  return useQuery({
    queryKey: ['livePrices', normalizedSymbols],
    queryFn: () =>
      httpJSON('/v1/prices/live', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ symbols: normalizedSymbols }),
      }),
    enabled: normalizedSymbols.length > 0,
    staleTime: 0,
    refetchInterval: 4000,
    refetchIntervalInBackground: false,
    ...options,
  });
}
